;"use strict";
window.overwatch = window.overwatch || {};
window.overwatch.PlatformModel = {

	Mediator: null,
	
	eventNameChange: null,

	defaultList: null,

	currentList: null,

	current: null,

	defaultPlatform: null,

	$doc: $(document),

	// TODO: externalize
	platformExceptions: null,

	init: function(config) {
		var self = this;

		this.Mediator = config.Mediator;
		this.eventNameChange = config.eventNameChange;
		this.defaultList = config.defaultPlatformList;
		this.currentList = this.defaultList;
		this.current = config.current;
		this.defaultPlatform = config.defaultPlatform;
		this.platformExceptions = config.platformExceptions;
	},

	updateList: function(skuId) {
		// filter out platform exceptions (platforms that don't support provided sku)
		var exceptions = this.platformExceptions[skuId];
		if (exceptions) {
			this.currentList = this.defaultList
				.filter(function filterUnsupported(platform) {
					return exceptions.indexOf(platform) === -1;
				});
		} else {
			this.currentList = this.defaultList;
		}

		// reset current platform if it's no longer supported after sku change
		if (this.currentList.indexOf(this.current) === -1) {
			this.setCurrent(this.defaultPlatform);
		}
	},

	getList: function() {
		return this.currentList;
	},

	getUnavailableList: function() {
		var currentList = this.currentList;
		return this.defaultList
			.filter(function filterSupported(platform) {
				return currentList.indexOf(platform) === -1;
			});
	},

	getCurrent: function() {
		return this.current;
	},

	setCurrent: function(platform) {
		this.current = platform;
		this._publish();
	},

	_publish: function() {
		this.Mediator.publish(this.eventNameChange, this.current);
	}

};
